<div class="card sidenav padding-bottom desktop-only">
  @for (group of allSidenavGroups; track group; let first = $first) {
    <div class="menu">
      @if (group.userType === userType) {
        @for (item of group.groupItems; track item) {
          <a
            class="item flex column center hover"
            [btActiveRoute]="[item.menuRoute].concat(item.childRoutes)"
            [routerLink]="['/', group.groupUrlPart, item.menuRoute]"
            [middleClick]="['/', group.groupUrlPart, item.menuRoute]"
            *btHasRole="item.requiredRoles"
          >
            <i [ngClass]="item.icon" class="menu-icon"></i>

            <div class="label" [title]="item.menuLabel">{{ item.menuLabel }}</div>
          </a>
        }
      }
    </div>
  }
</div>
